import { interpolate, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { getLoginSmsForm } from './keycloak-login-sms.config.js';

var KeycloakLoginSms = /** @class */ (function (_super) {
    __extends(KeycloakLoginSms, _super);
    function KeycloakLoginSms() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formConfig = null;
        _this.remainingMs = 0;
        return _this;
    }
    KeycloakLoginSms.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, summary, type, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.kcContext.message || {}, summary = _a.summary, type = _a.type;
                        _b = this;
                        return [4 /*yield*/, getLoginSmsForm(type === 'error' ? summary : undefined, type)];
                    case 1:
                        _b.formConfig = _c.sent();
                        this.remainingMs = this.getRemainingTime();
                        if (this.remainingMs > 0) {
                            this.startCooldownTimer();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    KeycloakLoginSms.prototype.startCooldownTimer = function () {
        var _this = this;
        this.cooldownInterval = setInterval(function () {
            _this.remainingMs -= 1000;
            if (_this.remainingMs <= 0) {
                clearInterval(_this.cooldownInterval);
            }
        }, 1000);
    };
    KeycloakLoginSms.prototype.getRemainingTime = function () {
        var expectedEndTime = this.getExpiration();
        if (!expectedEndTime) {
            return 0;
        }
        var now = Date.now();
        return expectedEndTime - now;
    };
    KeycloakLoginSms.prototype.getExpiration = function () {
        var expiration = this.kcContext.resend_cooldown_expected_at;
        if (!expiration) {
            return 0;
        }
        return parseInt(expiration, 10);
    };
    KeycloakLoginSms.prototype.destroyed = function () {
        if (this.cooldownInterval) {
            clearInterval(this.cooldownInterval);
        }
    };
    Object.defineProperty(KeycloakLoginSms.prototype, "loginAction", {
        get: function () {
            return this.kcContext.url.loginAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakLoginSms.prototype, "resendDisabled", {
        get: function () {
            return this.remainingMs > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakLoginSms.prototype, "resendMessage", {
        get: function () {
            return this.resendDisabled
                ? interpolate(this.$t('login-sms.resend-message-disabled'), {
                    seconds: Math.floor(this.remainingMs / 1000),
                })
                : this.$t('login-sms.resend-message');
        },
        enumerable: false,
        configurable: true
    });
    KeycloakLoginSms.prototype.submit = function (value) {
        var form = this.$refs.form;
        this.getInput(form, 'code').value = value.code;
        form.submit();
    };
    KeycloakLoginSms.prototype.resend = function () {
        if (this.resendDisabled) {
            return;
        }
        var form = this.$refs.form;
        this.getInput(form, 'resendButton').value = 'true';
        form.submit();
    };
    KeycloakLoginSms.prototype.getInput = function (form, name) {
        return form.elements.namedItem(name);
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakLoginSms.prototype, "kcContext", void 0);
    KeycloakLoginSms = __decorate([
        Component({
            name: 'corex-keycloak-login-sms',
        })
    ], KeycloakLoginSms);
    return KeycloakLoginSms;
}(Mixins(MagicConfigMixin)));

export default KeycloakLoginSms;
